import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrimInputDirective } from './trim-input.directive';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    TrimInputDirective
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    TrimInputDirective
  ]
})
export class TrimInputModule { }
